import { useMemo } from "react";
import { IItemProp } from "../../ui-lib/components/Dropdown/DropdownItem";
import Dropdown from "../../ui-lib/components/Dropdown/Dropdown";
import { ControllerRenderProps } from "react-hook-form";
import { IOrganizationDetails } from "../../core/api/organizations/types";
import useTranslations from "../../core/i18n/useTranslations";

export const SolutionTypeDropdown = ({
  required = true,
  field,
  hasError,
}: {
  required?: boolean;
  field: ControllerRenderProps<IOrganizationDetails, "solutionType">;
  hasError?: boolean;
}) => {
  const t = useTranslations();

  const solutionTypes: IItemProp[] = useMemo(
    () => [
      {
        id: 1,
        name: t("Organizations:solution_type_1"),
        isSelected: field.value === 1,
      },
      {
        id: 2,
        name: t("Organizations:solution_type_2"),
        isSelected: field.value === 2,
      },
      {
        id: 3,
        name: t("Organizations:solution_type_3"),
        isSelected: field.value === 3,
      },
    ],
    [field.value]
  );

  const selectedSolutionType = useMemo(
    () => solutionTypes.find((type) => type.isSelected),
    [field.value]
  );

  return (
    <Dropdown
      required={required}
      title={t("Organizations:solution_type_label")}
      placeholder={t("Organizations:select_solution_type")}
      items={solutionTypes}
      selectedItem={selectedSolutionType}
      onSelectItem={(item: IItemProp) => {
        if (item.id === field.value) return;
        field.onChange(item.id);
      }}
      validationError={hasError ? t("Errors:input_field_required") : undefined}
    />
  );
};
